import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, xcss } from '@atlaskit/primitives';
import Select from '@atlaskit/select';
import React from 'react';
import { CustomControlMobile } from '../Control';
import { CustomDropdownIndicator } from '../DropdownIndicator';
import { CustomMenu } from '../Menu';
import { CustomMenuList } from '../MenuList';
import { CustomNoOptionsMessage } from '../NoOptionsMessage';
import { CustomOptionMobile } from '../Option';
import { jsx as _jsx } from "react/jsx-runtime";
const customSelectStyles = {
  control: base => _objectSpread(_objectSpread({}, base), {}, {
    border: 0 // Removing the default border around the select control
  })
};
const customComponents = {
  Option: CustomOptionMobile,
  DropdownIndicator: CustomDropdownIndicator,
  Menu: CustomMenu,
  Control: CustomControlMobile,
  NoOptionsMessage: CustomNoOptionsMessage,
  MenuList: CustomMenuList
};
const wrapperStyles = xcss({
  fontFamily: 'font.family.brand.body',
  flex: '1',
  width: '100%',
  overflow: 'auto'
});
export const MobileSelect = _ref => {
  let {
    testId,
    options,
    selectedOptions,
    status = 'default',
    searchInputValue = '',
    isMulti = false,
    isSearchable = false,
    onSelectionChange,
    onSearchInputChange
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    xcss: wrapperStyles,
    children: /*#__PURE__*/_jsx(Select, {
      placeholder: "Search",
      testId: testId,
      options: options,
      value: selectedOptions,
      isMulti: isMulti,
      onChange: onSelectionChange,
      inputValue: searchInputValue,
      onInputChange: onSearchInputChange,
      components: customComponents,
      styles: customSelectStyles,
      menuIsOpen: true,
      autoFocus: true,
      blurInputOnSelect: true,
      closeMenuOnSelect: false,
      hideSelectedOptions: false,
      controlShouldRenderValue: false,
      menuShouldScrollIntoView: false,
      tabSelectsValue: false,
      defaultOptions: false,
      isClearable: false,
      escapeClearsValue: false,
      isSearchable: isSearchable,
      status: status
    })
  });
};